import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ChevronDownIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 15, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 8) / 15}
      viewBox="0 0 15 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.50003 8C7.32566 8 7.15111 7.93483 7.01799 7.80467L0.199815 1.13804C-0.066605 0.877537 -0.066605 0.455706 0.199815 0.195374C0.466235 -0.064958 0.897655 -0.0651247 1.1639 0.195374L7.50003 6.39068L13.8362 0.195374C14.1026 -0.0651247 14.534 -0.0651247 14.8002 0.195374C15.0665 0.455873 15.0667 0.877703 14.8002 1.13804L7.98208 7.80467C7.84895 7.93483 7.67441 8 7.50003 8Z"
        fill="currentColor"
      />
    </svg>
  )
})

ChevronDownIcon.displayName = 'ChevronDownIcon'
